import _extends from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var Logo = function Logo(_ref) {
  var props = _extends({}, _ref);

  var url = props.url || 'https://subkit-images.s3.amazonaws.com/images/logo.svg';
  var alt = props.altText || 'Subkit Logo';
  var classes = props.className || '';
  return /*#__PURE__*/_jsx("img", {
    src: url,
    alt: alt,
    className: 'h-auto my1 ' + classes
  });
};